<template>
  <div class="revt-page">
    <header-nav :current="current"></header-nav>
    <!-- 阶段量表开始提示 -->
    <template v-if="step == 0 || step == 3">
      <div class="exam-content">
        <div class="exam-tip-container">
          <div class="exam-label exam-label-container">
            <img src="../assets/img/pyrotechnics-big.png" alt="">
            <div class="exam-top-container">
              <img src="../assets/img/pyrotechnics-small.png" alt="">
              <div>施测前提醒</div>
            </div>
          </div>
          <div class="content-border">
            <ul class="exam-tips">
              <template v-if="step == 0">
                <li v-for="(tip, index) in stepContent[step]" :key="index" v-html="'提醒'+(index + 1)+'：'+tip"></li>
              </template>
              <template v-if="step == 3">
                <li v-for="(tip, index) in stepContent[step - 2]" :key="index" v-html="'提醒'+(index + 1)+'：'+tip"></li>
              </template>
            </ul>
            <div class="exam-next-btn" @click="showQuestion">
              <span class="span-btn">下一步</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="showStagePage">
      <div class="exam-stage">
        <div class="state-shadow"></div>
        <div class="exam-stage-cate">
          <div class="exam-stage-cate-title">
            表达量表
          </div>
          <div class="exam-question-type">
            {{ questionType == 1 ? '练习题' : '正式题' }}
          </div>
          <div class="express-url-container" v-if="showJoinCard" style="margin-top: 4vh;">
          </div>
          <div class="exam-next-btn">
            <span class="span-btn" @click="showQuestion">下一步</span>
          </div>
        </div>
      </div>
    </template>
    <template v-if="step == 1 || step == 4">
      <div class="exam-content">
        <div class="exam-tip-container steer-page-tip">
          <div class="exam-label exam-label-container">
            <img src="../assets/img/pyrotechnics-big.png" alt="">
            <div class="exam-top-container">
              <img src="../assets/img/pyrotechnics-small.png" alt="">
              <div>指导语</div>
            </div>
          </div>
          <div class="content-border min-height-content">
            <ul class="exam-tips">
              <li style="text-indent:0;margin-left: 0;">
                接下来你会看到一些图片，我会问你一些问题，请你把答案说出来，请你尽量试试看！
              </li>
            </ul>
          </div>
        </div>
        <div class="exam-begin-btn" @click="showQuestion">
          开始作答
        </div>
      </div>
    </template>
    <div class="question-container" style="display: flex;flex-direction: column" v-show="[2,5,6].indexOf(step) > -1 && !showStagePage">
      <div class="title" ref="questionTitleRef">
        <template v-if="question.question_type === 1">
          <div class="title-label">
            练习{{
              question.number
            }}{{ question.number_count > 1 ? '-' + question.sort : '' }}
            <template v-if="question.quiz_items === 1">
              （命名）
            </template>
            <template v-if="question.quiz_items === 2">
              （归类）
            </template>
            <template v-if="question.quiz_items === 3">
              （定义）
            </template>
            <template v-if="question.quiz_items === 4">
              （推理）
            </template>
          </div>
          {{question.subject.length > 0 ? question.title : ''}}
        </template>
        <template v-else>
          <span class="title-label" style="color: #000">
            第&nbsp;{{ question.number }}{{ question.number_count > 1 ? '-' + question.sort : '' }}&nbsp;题
          </span>&nbsp;
          {{question.subject && question.subject.length > 0 ? question.title : '' }}
        </template>
      </div>
      <template v-if="question.action_guide && question.action_guide.length > 0">
        <span class="action-guide">（{{question.action_guide}}）</span>
      </template>

      <div class="express" v-show="answerWay === 2">
        <div class="question-info question-placeholder" v-show="loadedExpress" v-if="question.answer_way === 2">
          <div class="question-placeholder-content">
            <template v-if="question.subject.length > 0">
              <img class="question-img" ref="expressPic" @load="loadExpressPic" :src="question.subject" alt="">
            </template>
            <template v-else>
              <div class="question-img" style="height: 50vh;border: none;box-shadow: none">
                <h1>{{ question.title }}</h1>
              </div>
            </template>
          </div>
          <div class="question-steers" ref="steersRef" v-show="loadedExpress" :style="{width: expressWidth + 'px',alignItems:'center'}">
            <div class="steers-container steer-placeholder">
              <div class="steer-items bottomer" @click="sendVoiceUrl(item.path)" v-for="(item,index) in steers" :key="index">{{item.title}}</div>
            </div>
            <!-- show_mark === 1 ? 'left' : 'center' -->
            <div class="express-question-remark" :style="{textAlign: question.show_mark === 1 ? 'left' : 'left'}">
              <template v-if="question.steers_tip && question.steers_tip.length > 0">
                ※{{question.steers_tip}}
              </template>
              <template v-if="questionType === 1 && question.show_mark === 1">
                ※若儿童回答错误，施测者可以示范正确答案并说明为什么，并再练习一次（限再练习一次）。
              </template>
            </div>
          </div>
        </div>
        <div class="show-loading" v-show="!loadedExpress" :style="{width:expressWidth+'px'}">
          <div class="loader">
            <div class="pacman">
              <div class="mouth"></div>
            </div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="answer-info" style="display: flex;flex-direction: column;">
          <div class="answer">
            <div class="answer-label">
              答案
              <template v-if="question.number === 28"><span style="font-weight: normal">（选择四个即可）</span></template>
              <template v-if="question.number === 54"><span style="font-weight: normal">（选择三个即可）</span></template>
              <template v-if="question.number === 56"><span style="font-weight: normal">（选择两个即可）</span></template>
              <template v-if="question.number === 57"><span style="font-weight: normal">（选择两个即可）</span></template>
              <template v-if="question.number === 63"><span style="font-weight: normal">（选择三个即可）</span></template>
              :
            </div>
            <div class="answer-item">
              <el-checkbox-group v-model="checkList">
                <el-checkbox :label="answer.label" v-for="(answer, index) in candidateAnswer" :key="index" @change="chooseAnswerHandler">
                  {{answer.label}}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <template v-if="question.standard_answer && question.standard_answer.length > 0">
              <span class="action-guide standard-answer">{{question.standard_answer}}</span>
            </template>
          </div>
          <div class="answer-other-info" style="flex: 1">
            <div class="steer-tip" v-if="question.tip && question.tip.length > 0">
              <span >不计分答案范例：</span><br>
              <p class="case-tip">{{ question.tip }}</p>
            </div>
            <div class="steer-tip" style="color: #868686;" v-if="question.steer_tip && question.steer_tip.length > 0">
              {{ question.steer_tip }}
            </div>
          </div>

          <div class="option-btns">
            <div class="default-btn next-btn" @click="nextQuestion">
              <span>下一题</span>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div class="connect" v-if="!connect">当前服务端连接失败，将无法进行表达量表的施测。</div>
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav'
import WebSocketClient from '@/libs/websocket-client'
import GLOBAL from '@/config/config'

export default {
  name: 'revt',
  data () {
    return {
      ctx: null,
      img: null,
      expressWidth: null,
      scale: 1,
      offsetX: 0,
      offsetY: 0,
      selections: [],
      coordinate: [],
      checking: false,
      current: 'evaluation',
      steers: [],
      questionType: 1,
      examType: 1,
      answerWay: 1,
      question: {},
      candidateAnswer: [],
      checkList: [],
      loading: null,
      step: 3,
      stepContent: [
        [],
        [
          '请同步使用另一台手机/平板或是计算机登入后台，同步记录儿童作答结果。',
          '如果回答出正确答案，请点选答案前方的圆圈。如果回答不正确或回答不出来，可以按下右侧“下一题”直接进入下一题。',
          '得分2分的题目，系统最多追问一次“还有吗？再说说看。”<br>得分3分的题目，系统最多追问两次。<br>得分4分的题目，系统最多追问三次。',
          '后台的答案有【追】字者，代表接近正确答案，但还不是正确答案，须请儿童加以澄清，施测者可以追问一次，但以一次为限，若仍回答错误，则按“下一题”进入下一题。',
          '题目有【引导】两字者，施测者可依引导内容，对儿童作适当引导，但引导内容须依题目指示，不宜过度引导。标示【不引导】者，则不提供任何线索，但可依照提醒3的标准追问。',
          '题目会随着受试者程度跳题作答，计分时请确认题号再给分。'
        ]
      ],
      uid: '',
      wsClient: null,
      needAuth: true, // 需要重新认证的标记
      connect: true,
      joinNewUser: false,
      showStagePage: false,
      showJoinCard: false,
      chooseAnswer: [],
      exam_id:0,
      invalid:false,
      baseWidth:1920,
      loadedExpress: false,
      selfClick: false
    }
  },
  mounted () {
    this.resizeScale()
    window.addEventListener('keydown', this.spaceKeyDownHandler)
    window.addEventListener('resize',this.resizeScale)
    this.uid = this.$route.query.sign
    this.initExam()
  },
  created () {
  },
  methods: {
    resizeScale(){
      let screenWidth = document.documentElement.clientWidth
      let scale = screenWidth / this.baseWidth
      let page = document.querySelector('.revt-page')
      page.style.setProperty('--scale', scale)
      page.style.setProperty('--content-height','calc(100vh - 90px)')
      this.codeSize = 100 * scale
    },
    handlerLoadDomHeight(){
      this.$nextTick(() => {
        let page = document.querySelector('.revt-page')
        page.style.setProperty('--steers-height', Math.ceil(this.$refs.steersRef.offsetHeight) + 1 + 'px')
        page.style.setProperty('--title-height', Math.ceil(this.$refs.questionTitleRef.offsetHeight) + 1 + 'px')
      })
    },
    // 初始化websocket连接
    initWebSocket () {
      this.wsClient = new WebSocketClient(GLOBAL.WEBSOCKETIP, {
        reconnMaxAttempts: Infinity // 无限重试
      })
      this.wsClient
          .on('onopen', () => {
            // 连接/重连后发送必要消息
            this.connect = true
            setTimeout(res => {
              this.clientJoinGroup()
            }, 300)
          })
          .on('onreconnect', (attempts) => {

          })
          .on('onmessage', (e) => {
            // 处理业务消息
            const data = JSON.parse(e.data)
            this.handleMessage(data)
          })
          .on('onclose', (e) => {
            this.connect = false
            console.log('连接失败', 'close')
          })
          .on('onerror', (e) => {
            this.connect = false
            console.log('连接失败')
          })

      this.wsClient.connect()
    },

    // 客户端断线重连重新加入分组
    clientJoinGroup() {
      this.wsClient.send({
        type: 'join',
        content: { group: this.uid,user:'tester:'+this.uid}
      })
    },
    initExam () {
      this.$post('canvas/init', {client: 1,room:this.uid}).then(res => {
        let question = res.data
        this.showStagePage = false
        this.step = 3
        this.showJoinCard = false
        if (res.code == 200){
          this.exam_id = res.exam
          this.examType = question.exam_type
          this.answerWay = question.answer_way
          this.questionType = question.question_type
          this.question = question
          this.candidateAnswer = question.answer
          this.steers = question.steers
          this.initWebSocket()
        } else {
          this.invalid = true
          this.$layer.msg(res.msg)
        }
      })
    },
    /**
     * 获取指定题目信息
     * @param params
     */
    getQuestionInfo (params = {}) {
      params.sign = this.uid
      let oldInfo = this.question
      this.loadedExpress = false
      this.$post('canvas/saveAndNext', params).then(res => {
        if (res.code === 200) {
          this.checkList = []
          this.selections = []
          if (this.ctx) {
            this.clearResult()
          }
          let question = res.data
          this.steers = question.steers
          // 量表阶段变更：理解->表达
          if (oldInfo.exam_type != question.exam_type && question.exam_type == 2 && !question.jump) {
            this.showStagePage = true
            this.step = 3
            this.showJoinCard = true
          }
          // 上一题和下一题题目类型不一致了
          if (oldInfo.question_type == 1 && question.question_type == 2 && !question.jump) {
            // 理解量表到表达量表
            this.showStagePage = true
          }
          if (question.subject.length === 0) {
            // 没有图片
            this.loadedExpress = true
          } else {
            let expressImgContainer = this.$refs.expressPic
            if (expressImgContainer) {
              expressImgContainer.src = ''
            }
          }
          this.examType = question.exam_type
          this.answerWay = question.answer_way
          this.questionType = question.question_type
          this.question = question
          this.candidateAnswer = question.answer
        }
        if (res.code === 500){
          this.invalid = true
          this.$layer.msg(res.msg)
        }
      })
    },


    // 坐标转换
    toOriginalCoords (canvasX, canvasY) {
      return {
        x: Math.round((canvasX - this.offsetX) / this.scale),
        y: Math.round((canvasY - this.offsetY) / this.scale)
      }
    },
    // 获取下一题
    nextQuestion () {
      if (this.invalid){
        this.$layer.msg('当前施测信息不存在，请稍后再试。')
        return false
      }
      let chooseAnswer = []
      if (this.answerWay == 1) {
        // 图片交互
        chooseAnswer = this.selections
      }
      if (this.answerWay == 2) {
        // 双屏
        chooseAnswer = this.checkList
      }
      this.chooseAnswer = chooseAnswer
      let level = this.question.number_count > 1 && this.question.level == 0 ? 1 : 0
      let params = {
        exam_id: this.exam_id,
        level: this.question.level,
        number: this.question.number,
        ques_id: this.question.id,
        question_type: this.question.question_type,
        answer: this.chooseAnswer,
        sort: this.question.sort
      }
      if (chooseAnswer.length == 0) {
        this.$confirm('您当前未选择有效回答，确定要继续提交吗？', '', {
          showClose: false,
          closeOnClickModal: false,
          center: true,
          distinguishCancelAndClose: true,
          confirmButtonText: '继续提交',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirm-submit',
          cancelButtonClass: 'cancel-submit'
        }).then(res => {
          this.selfClick = true
          this.getQuestionInfo(params)
          // websocket
        }).catch(err => {

        })
      } else {
        // websocket
        this.selfClick = true
        this.getQuestionInfo(params)
      }
    },
    // 处理websocket接收到的消息
    handleMessage (data) {
      switch (data.type) {
        case 'news':
          if (this.selfClick) {
            this.selfClick = false
            return false
          }
          this.loadedExpress = false
          let question = data.content.question
          let expressImgContainer = this.$refs.expressPic
          if (expressImgContainer) {
            expressImgContainer.src = ''
          }
          let oldInfo = this.question
          if (this.loading) {
            this.loading.close()
          }
          this.steers = question.steers
          // 量表阶段变更：理解->表达
          if (oldInfo.exam_type !== question.exam_type && question.exam_type === 2 && !question.jump) {
            this.showStagePage = true
            this.step = 3
            this.showJoinCard = true
          }
          // 上一题和下一题题目类型不一致了
          if (oldInfo.question_type === 1 && question.question_type === 2 && !question.jump) {
            // 理解量表到表达量表
            this.showStagePage = true
          }
          // 重新获取图片展示宽度并赋值给引导内容
          // if (question.exam_type === 2 && !this.showStagePage) {
          //   this.loadExpressPic()
          // }

          if (question.subject.length === 0) {
            // 没有图片
            this.loadedExpress = true
          }
          this.examType = question.exam_type
          this.answerWay = question.answer_way
          this.questionType = question.question_type
          this.question = question
          this.candidateAnswer = question.answer
          break
        case 'loading':
          // 加载新题目中
          // this.loading = this.$loading({
          //   lock: true,
          //   text: '题目加载中',
          //   spinner: 'el-icon-loading',
          //   background: 'rgba(0, 0, 0, 0.4)'
          // })
          break
        case 'error':

          break
        case 'finish':
        case 'invalid':
          this.$alert(data.message, {
            confirmButtonText: '前往我的测评',
            confirmButtonClass: 'confirm-submit',
            showClose: false,
            center: true,
            callback: action => {
              // console.log('跳转')
              this.$router.push('/InventoryList')
            }
          })
          this.$confirm('当前用户施测已结束。', '', {
            showClose: false,
            closeOnClickModal: false,
            center: true,
            distinguishCancelAndClose: true,
            confirmButtonText: '前往我的测评',
            cancelButtonText: '返回首页',
            confirmButtonClass: 'confirm-submit',
            cancelButtonClass: 'cancel-submit'
          }).then(res => {
            this.$router.push('/InventoryList')
          }).catch(err => {
            this.$router.push('/index')
          })

          break
        case 'join success':
          if (data.content.user != this.uid) {
            this.joinNewUser = true
            setTimeout(() => {
              this.joinNewUser = false
            }, 3000)
          }
          break;
        case 'next':
          // 施测端和用户端互动切屏
          this.step = data.content.step
          if (data.content.step === 4) {
            // 显示指导语
            this.showStagePage = false
          }
          if (data.content.step == 5) {
            this.loadExpressPic()
            // console.log('开始答题');
          }
          if (data.content.step == 6) {
            this.loadExpressPic()
            this.showStagePage = false
          }
          break;
      }
    },
    // 推送消息到服务端
    sendMessage (data = {type: 'chat', content: 'Hello World'}) {
      if (this.question.exam_type == 2 || data.type == 'join') {
        const success = this.wsClient.send(data)
        if (!success) {
          this.$message.error('发送失败，连接已断开')
        }
      }
    },
    /**
     * 监听空格事件
     * @param event
     */
    spaceKeyDownHandler (event) {
      if (this.invalid){
        this.$layer.msg('当前施测信息不存在，请稍后再试。')
        return false
      }
      let step = this.step
      // 练习题阶段
      if (event.keyCode == 32 && [0, 3].indexOf(step) > -1) {
        this.setQuestionStagePage()
      }
      // 练习题转正式题阶段
      if (event.keyCode == 32 && [2, 5].indexOf(step) > -1 && this.showStagePage) {
        this.setQuestionStagePage()
      }
    },
    // 展示题目信息
    showQuestion () {
      if (this.invalid){
        this.$layer.msg('当前施测信息不存在，请稍后再试。')
        return false
      }
      this.loadExpressPic()
      this.setQuestionStagePage()
    },
    setQuestionStagePage () {
      let step = this.step
      switch (step) {
        case 3:
          // 显示表达量表阶段、施测前提醒
          // 检测施测端是否加入
          this.checkClientJoin((res) => {
            if (res) {
              if (step === 3){
                this.updateClientState('next',4)
              }
              this.step = this.showStagePage ? 3 : 4
              if (this.step === 3) {
                this.showJoinCard = true
              }
              this.showStagePage = this.showStagePage === true ? false : false
              if (!this.showStagePage){
                this.updateClientState()
              }
            }
          })
          break
        case 4:
          // 表达量表引导语，要通知测试端显示题目
          this.step++
          // console.log('xianshilianxi')
          this.updateClientState('next',5)
          this.handlerLoadDomHeight()
          this.loadExpressPic()
          break
        case 5:
          // console.log('dowu')
          // 表达量表正式题
          this.showStagePage = this.showStagePage === true ? false : false
          if (!this.showStagePage) {
            // this.updateClientState()
          }
          this.updateClientState('next',6)
          this.handlerLoadDomHeight()
          // 要通知客户端显示题目
          break
      }
    },
    getString () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    getGuid () {
      return (this.getString() + this.getString() + '-' + this.getString() + '-' + this.getString() + '-' + this.getString() + this.getString() + this.getString() + this.getString())
    },
    checkClientJoin (callback) {
      this.$post('canvas/checkClient', {sign: this.uid}).then(res => {
        if (res.code == 200 && res.data == 2) {
          callback(true)
        } else {
          this.$layer.msg(res.msg)
          callback(false)
        }
      })
    },
    updateClientState (type = 'stage',step=false) {
      this.sendMessage({
        type: type,
        content: {
          group: this.uid,
          step: !step ? this.step : step,
          stage: this.showStagePage
        }
      })
    },
    chooseAnswerHandler(){
      this.sendMessage({
        type: 'choose',
        content: {
          group: this.uid,
          answer:JSON.stringify(this.checkList)
        }
      })
    },
    loadExpressPic () {
      if (!this.showStagePage && (this.step === 5 || this.step === 6) && this.question.subject.length > 0){
        this.$nextTick(()=>{
          setTimeout(()=>{
            this.expressWidth = this.$refs.expressPic.width
          },10)
        })
      }

      this.loadedExpress = true
    },
    sendVoiceUrl(path = ''){
      if (path === null || path === '') {
        return false
      }
      let data = {
        type: 'play',
        content: {
          group: this.uid,
          url: path,
        }
      }
      this.sendMessage(data)
    }
  },
  beforeDestroy () {
    if (this.wsClient) {
      this.wsClient.close()
    }
    window.removeEventListener('keydown', this.spaceKeyDownHandler)
    window.removeEventListener('resize',this.resizeScale)
  },
  components: {
    HeaderNav
  }
}
</script>
<style>
:root{
  --title-height:50px;
  --steer-height:80px;
}
p > img,
span > img {
  max-height: 50vh;
  width: auto;
  height: auto;
  max-width: 50vw;
}

body {
  background-color: #ffffff !important;
  user-select: none;
}

.confirm-submit {
  background-color: #f39902 !important;
  color: #ffffff;
  border: 1px solid #f39902 !important;
}

.confirm-submit:hover {
  background-color: #f39902d1 !important;
  color: #ffffff;
  border: 1px solid #f39902d1 !important;
}

.cancel-submit:hover {
  background-color: #e6e6e6 !important;
  color: #000000;
  border: 1px solid #e6e6e6 !important;
}

/* p>img{
    width: 100%;
} */
.el-checkbox-group {
  display: flex;
  flex-direction: column;
}

.el-checkbox {
  margin: calc(4px * var(--scale)) 0;
  font-size: calc(14px * var(--scale));
}

.el-checkbox__inner {
  border-radius: 50% !important;
  width: calc(20px * var(--scale));
  height: calc(20px * var(--scale));
}

.el-checkbox__inner::after {
  height: calc(8px * var(--scale));
  width: calc(8px * var(--scale));
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  border: none !important;
  background-color: #fff;
  border-radius: 50% !important;
}

.el-checkbox__label {
  font-size: calc(20px * var(--scale));
  padding-left: calc(10px * var(--scale));
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f39902;
  border-color: #f39902;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #f39902;
}

.el-checkbox__inner:hover {
  border-color: #f39902;
}

.el-message-box__headerbtn:hover {
  color: #f39902 !important;
}

</style>
<style scoped lang="less">
::v-deep .el-checkbox__label{
  color: #000000 !important;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #f39902 !important;
}

.question-img {
  //padding-top: 16px;
  max-height: calc(95vh - 90px - var(--steers-height) - var(--title-height));
  width: auto;
  height: auto;
  max-width: 45vw;
  border: 1px solid #e7e7e7;
  box-sizing: border-box;
  box-shadow: 0px 0px 5px 0px #a9a9a9;
  border-radius: 8px;
}
@import url('../assets/css/page/revt_center_teacher');
@import url('../assets/css/revt_load');
</style>